
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,

  ModalBody,
  ModalCloseButton,
  Button,

} from '@chakra-ui/react'
const CustomModal = ({ showModalButtonText, modalHeader, modalBody, isOpen, onOpen, onClose, size = "xl", isNotHideButton = true }) => {



  return (
    <>
      {isNotHideButton && (
        <Button colorScheme="white" background={"var(--brand-primary)"} className='custom-chakra-button' padding="20px" fontSize="14px" fontWeight="400" fontFamily="Lato, sans-serif"
          color="#fff" onClick={onOpen}>
          {showModalButtonText}
        </Button>
      )}

      <Modal isOpen={isOpen} size={size} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontSize="32px" fontWeight="300" color="#000000" my="0px" fontFamily="'Inter', sans-serif">{modalHeader}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>

            {modalBody}

          </ModalBody>


        </ModalContent>
      </Modal>
    </>
  );
};

export default CustomModal;